import { useMutation } from '@tanstack/react-query';
import { Api } from 'hooks';
import { withAcl } from 'hooks/Api';
import useModal from 'ui/partials/Modal/useModal';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import {
  DATA_RECORD_ACTION,
  DATA_RECORD_SOURCE,
  DataRecord,
} from 'utils/types';

const useCreateCustomExport = () => {
  const { state } = useProvider();
  const args = state;
  const { accountId, accountUserId } = useAdminParams();
  const { hideModal } = useModal();

  return useMutation<
    DataRecord,
    Error,
    {
      source: DATA_RECORD_SOURCE;
      action: DATA_RECORD_ACTION;
      meta: {
        fields: { key?: string; dataId?: string }[];
      };
    }
  >({
    mutationFn: async (payload) => {
      const api = new Api(args);

      const data = await api.post(
        await withAcl({
          account: {
            url: 'api/v1/data/records/export',
            payload,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/data/records/export`,
            payload,
          },
        }),
      );
      return data;
    },
    onSuccess: () => {
      toastSuccess('Successfully created export');
      hideModal();
    },
  });
};

export default useCreateCustomExport;
